package app.footyguide.web.page

import kotlinx.datetime.DatePeriod
import kotlinx.datetime.LocalDate
import kotlinx.datetime.minus
import kotlinx.datetime.plus

private const val DEFAULT_PAST_DAYS = 0
private const val DEFAULT_FUTURE_DAYS = 21
private const val DEFAULT_PREPEND_DAYS = 14

fun buildInitialScrollerDates(
    today: LocalDate,
    pastDays: Int = DEFAULT_PAST_DAYS,
    futureDays: Int = DEFAULT_FUTURE_DAYS,
): List<LocalDate> {
    return ((-pastDays)..futureDays).map { offset ->
        today.plus(DatePeriod(days = offset))
    }
}

fun prependScrollerDates(
    currentDates: List<LocalDate>,
    days: Int = DEFAULT_PREPEND_DAYS,
): List<LocalDate> {
    if (currentDates.isEmpty() || days <= 0) return currentDates

    val firstDate = currentDates.first()
    val previousDates = (days downTo 1).map { offset ->
        firstDate.minus(DatePeriod(days = offset))
    }

    return previousDates + currentDates
}

fun defaultSelectedDate(
    today: LocalDate,
    initialDate: String? = null,
): LocalDate {
    return initialDate?.let { LocalDate.parse(it) } ?: today
}
